import axios from 'axios';
import { handleResponse } from './HelperService';

const getAllStockReady = (params, onSuccess, onError) => {
    const response = axios.get('v1/productstock/branch', {params});
    return handleResponse(response, onSuccess, onError);
};


export {getAllStockReady}